import { Injectable } from '@angular/core';
import { HttpService } from '@seco/core';
import { Store } from '@ngrx/store';
import { EnvironmentConfig } from '../models/env.model';
import { GetClpConfigError } from '../login/core.actions';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    private readonly envConfig$: BehaviorSubject<EnvironmentConfig> = new BehaviorSubject(null);
    private readonly BUILD_ENV_CONFIG = 'buildEnvConfig';

    constructor(private readonly httpService: HttpService,
        private readonly store: Store<any>) { }

    /**
     * Method for loading configuration
     */
    loadConfiguration() {
         const model = {
            AD_JAVA_API_URL: window.location.origin+'/api/',
            AD_MAGENTO_URL: window.location.origin+'/mw/api/v1/',
            AD_IS_PROD: window.location.href.includes("portal"),
        };
        this.envConfig$.next(model);
    }

    updateEnvConfig(config: any) {
        this.envConfig$.next(config);
    }

    getEnvConfig(): EnvironmentConfig {
        return this.envConfig$.getValue();
    }

    getEnvConfigObs(): Observable<EnvironmentConfig> {
        return this.envConfig$.asObservable();
    }
}
